import React, {useEffect, useState} from "react"
import {connect, useDispatch} from "react-redux"
import withRouter from "../../components/Common/withRouter";
import {Button, Card, CardBody, Col, Form, FormFeedback, Input, Label, Row} from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"

import {useFormik} from "formik"
import * as Yup from "yup"
import {createCompany} from "../../store/Company/actions";
import Dropzone from "react-dropzone";
import {Link} from "react-router-dom";
import {getTokenFromLocalStorage} from "../../utils/Token";
const Add = props => {

    const [selectedFilesErr3, setSelectedFilesErr3] = useState(false)
    const [selectedFiles, setselectedFiles] = useState([])

    function formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return "0 Bytes"
        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

        const i = Math.floor(Math.log(bytes) / Math.log(k))
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
    }

    function handleAcceptedFiles(files) {
        files.map(file => {
                if (file.size >= 3022117) {
                    setSelectedFilesErr3(true)
                    setselectedFiles([])
                    return false
                } else {
                    Object.assign(file, {
                        preview: URL.createObjectURL(file),
                        formattedSize: formatBytes(file.size),
                    })
                }
            }
        )
        setselectedFiles(files)
    }


    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: "",
            companyName: "",
            companyId: "",
            phone: "",
            address: "",
        },
        validationSchema: Yup.object({
            email: Yup.string().required("შეიყვანეთ ელ-ფოსტა"),
            companyName: Yup.string().required("შეიყვანეთ სახელი"),
            companyId: Yup.string().required("შეიყვანეთ კომპანის საიდენტიფიკაციო ნომერი"),
            phone: Yup.string().required("შეიყვანეთ ტელეფონი"),
            address: Yup.string().required("შეიყვანეთ მისამართი"),
        }),

        onSubmit: async (values) => {
            try {
                const item = {
                    email: values.email,
                    companyName: values.companyName,
                    companyId: values.companyId,
                    phone: values.phone,
                    address: values.address,
                };


                const token = getTokenFromLocalStorage();
                const resp = await fetch(`${process.env.REACT_APP_SERVER_URL}/api2/company/create`, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`
                    },
                    body: JSON.stringify(item)
                });

                const data = await resp.json();
                if (!resp.ok || !data?.success) {
                    console.error("Create company failed:", data);
                    return;
                }

                const newCompanyId = data.result._id;

                // 2) загружаем файлы (если есть)
                if (selectedFiles?.length) {
                    for (const f of selectedFiles) {
                        await uploadFileForCompany({ companyId: newCompanyId, file: f });
                    }
                }

                // 3) очистка формы
                validation.resetForm();
                setselectedFiles([]);
                setSelectedFilesErr3(false);

            } catch (e) {
                console.error(e);
            }
        }

    })

    const uploadFileForCompany = async ({ companyId, file }) => {
        let token = getTokenFromLocalStorage();

        const fd = new FormData();
        fd.append("file", file);

        const resp = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/api2/upload/files/${companyId}/company`,
            {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                    // Content-Type НЕ ставим
                },
                body: fd
            }
        );

        return await resp.json();
    };



    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title={process.env.REACT_APP_PROJECT_NAME}
                                 breadcrumbItem="ახალი კომპანიის დამატება"/>

                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <Form
                                        className="form-horizontal"
                                        onSubmit={(e) => {
                                            e.preventDefault()
                                            validation.handleSubmit()
                                            return false
                                        }}
                                    >

                                        <Row>

                                            <Col lg="6">
                                                <div className="mb-3">
                                                    <Label className="form-label">კომპანიის სახელი</Label>
                                                    <Input
                                                        name="companyName"
                                                        className="form-control"
                                                        type="text"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.companyName || ""}
                                                        invalid={
                                                            validation.touched.companyName && validation.errors.companyName ? true : false
                                                        }
                                                    />
                                                    {validation.touched.companyName && validation.errors.companyName ? (
                                                        <FormFeedback
                                                            type="invalid">{validation.errors.companyName}</FormFeedback>
                                                    ) : null}
                                                </div>
                                            </Col>

                                            <Col md="12">

                                            </Col>
                                            <Col lg="6">
                                                <div className="mb-3">
                                                    <Label className="form-label">ელ-ფოსტა</Label>
                                                    <Input
                                                        name="email"
                                                        className="form-control"
                                                        type="text"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.email || ""}
                                                        invalid={
                                                            validation.touched.email && validation.errors.email ? true : false
                                                        }
                                                    />
                                                    {validation.touched.email && validation.errors.email ? (
                                                        <FormFeedback
                                                            type="invalid">{validation.errors.email}</FormFeedback>
                                                    ) : null}
                                                </div>
                                            </Col>


                                            <Col lg="6">
                                                <div className="mb-3">
                                                    <Label className="form-label">კომპანიის საიდენტიფიკაციაა</Label>
                                                    <Input
                                                        name="companyId"
                                                        className="form-control"
                                                        type="text"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.companyId || ""}
                                                        invalid={
                                                            validation.touched.companyId && validation.errors.companyId ? true : false
                                                        }
                                                    />
                                                    {validation.touched.companyId && validation.errors.companyId ? (
                                                        <FormFeedback
                                                            type="invalid">{validation.errors.companyId}</FormFeedback>
                                                    ) : null}
                                                </div>
                                            </Col>

                                            <Col lg="6">
                                                <div className="mb-3">
                                                    <Label className="form-label">კომპანის ტელეფონის ნომერი</Label>
                                                    <Input
                                                        name="phone"
                                                        className="form-control"
                                                        type="text"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.phone || ""}
                                                        invalid={
                                                            validation.touched.phone && validation.errors.phone ? true : false
                                                        }
                                                    />
                                                    {validation.touched.phone && validation.errors.phone ? (
                                                        <FormFeedback
                                                            type="invalid">{validation.errors.phone}</FormFeedback>
                                                    ) : null}
                                                </div>
                                            </Col>

                                            <Col lg="6">
                                                <div className="mb-3">
                                                    <Label className="form-label">კომპანის მისამართი</Label>
                                                    <Input
                                                        name="address"
                                                        className="form-control"
                                                        type="text"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.address || ""}
                                                        invalid={
                                                            validation.touched.address && validation.errors.address ? true : false
                                                        }
                                                    />
                                                    {validation.touched.address && validation.errors.address ? (
                                                        <FormFeedback
                                                            type="invalid">{validation.errors.address}</FormFeedback>
                                                    ) : null}
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Dropzone
                                                        accept={{
                                                            "image/*": [".png", ".jpg", ".jpeg", ".gif", ".webp"],
                                                            "application/pdf": [".pdf"],
                                                        }}
                                                        multiple
                                                        onDrop={(acceptedFiles) => handleAcceptedFiles(acceptedFiles)}
                                                        onDropRejected={(fileRejections) => {
                                                            // покажем ошибку и, например, имена отклонённых файлов
                                                            setSelectedFilesErr3(true);
                                                            console.warn(
                                                                "Rejected:",
                                                                fileRejections.map(r => ({ name: r.file.name, errors: r.errors }))
                                                            );
                                                        }}
                                                    >
                                                        {({ getRootProps, getInputProps }) => (
                                                            <div className="dropzone">
                                                                <div
                                                                    className="dz-message needsclick"
                                                                    style={{ fontSize: "17px" }}
                                                                    {...getRootProps()}
                                                                >
                                                                    <input {...getInputProps()} />
                                                                    <p>ატვირთეთ ფაილები: PDF, Excel, Word, TXT ან PNG</p>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Dropzone>
                                                    {
                                                        selectedFilesErr3
                                                            ? <span style={{color: 'red'}}><i>ატვირთეთ ფაილები: PDF, Excel, Word, TXT ან PNG</i></span>
                                                            : null
                                                    }
                                                    <div className="dropzone-previews mt-3" id="file-previews">
                                                        {selectedFiles.map((f, i) => {
                                                            return (
                                                                <Card
                                                                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                                                    key={i + "-file"}
                                                                >
                                                                    <div className="p-2">
                                                                        <Row className="align-items-center">
                                                                            {/* <Col className="col-auto">
                                                                                <img
                                                                                    data-dz-thumbnail=""
                                                                                    height="80"
                                                                                    className="avatar-sm rounded bg-light"
                                                                                    alt={f.name}
                                                                                    src={f.preview}
                                                                                />
                                                                            </Col>*/}
                                                                            <Col>
                                                                                <Link
                                                                                    to="#"
                                                                                    className="text-muted font-weight-bold"
                                                                                >
                                                                                    {f.name}
                                                                                </Link>
                                                                                <p className="mb-0">
                                                                                    <strong>{f.formattedSize}</strong>
                                                                                </p>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                </Card>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col lg="6">
                                                <button
                                                    className="btn btn-primary w-100 waves-effect waves-light"
                                                    type="submit"
                                                >
                                                    დამატება
                                                </button>
                                            </Col>
                                        </Row>

                                    </Form>

                                </CardBody>
                            </Card>

                        </Col>
                    </Row>

                </div>
            </div>
        </React.Fragment>

    )
}

export default withRouter(Add)
